import { useSite } from "../context/SiteContext";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Cursor from "../components/Cursor";
import Hero from "../components/home/Hero";
import Manifesto from "../components/home/Manifesto";
import PlusConnects from "../components/home/PlusConnects";
import WhoWeAre from "../components/home/WhoWeAre";
import Territory from "../components/home/Territory";
import Talents from "../components/home/Talents";
import WhatWeDo from "../components/home/WhatWeDo";
import CreativeThinking from "../components/home/CreativeThinking";
import Projects from "../components/home/Projects";
import Partnership from "../components/home/Partnership";
import People from "../components/home/People";
import Philosophy from "../components/home/Philosophy";
import FinalCta from "../components/home/FinalCta";
import Contact from "../components/home/Contact";

export default function Home() {
    const { site, failed } = useSite();

    if (!site) {
        return (
            <div className="flex h-screen items-center justify-center bg-[#0A0A0A]" data-testid="site-loader">
                <span className="font-display animate-pulse text-6xl text-[#D60024]">{failed ? "!" : "+"}</span>
            </div>
        );
    }

    return (
        <main className="bg-[#0A0A0A] text-white antialiased">
            <Cursor />
            <Header />
            <Hero />
            <Manifesto />
            <PlusConnects />
            <WhoWeAre />
            <Territory />
            <Talents />
            <WhatWeDo />
            <CreativeThinking />
            <Projects />
            <Partnership />
            <People />
            <Philosophy />
            <FinalCta />
            <Contact />
            <Footer />
        </main>
    );
}
